export { default as messagesReducers } from 'messages/reducers/messages_reducers';



// WEBPACK FOOTER //
// src/modules/messages/reducers/index.js